enum RotateDialogFields {
	ROTATION = 'rotation',
	DIRECTION = 'direction',
	PAGES = 'pages',
	PAGERANGE = 'pagerange',
	ORIENTATION = 'orientation'
}

export default RotateDialogFields;